/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  containsBytes,
  fixEncoderSize,
  getBytesEncoder,
  type Address,
  type ReadonlyUint8Array,
} from "@solana/kit";
import {
  type ParsedActivateAgentInstruction,
  type ParsedApproveDeliveryInstruction,
  type ParsedArbitrateDisputeInstruction,
  type ParsedAutoCreateGhostInstruction,
  type ParsedClaimGhostInstruction,
  type ParsedCreateAgentAuthorizationInstruction,
  type ParsedCreateCredentialTemplateInstruction,
  type ParsedCreateCredentialTypeInstruction,
  type ParsedCreateDidDocumentInstruction,
  type ParsedCreateEscrowInstruction,
  type ParsedCreateMultisigInstruction,
  type ParsedDeactivateAgentInstruction,
  type ParsedDeactivateCredentialTemplateInstruction,
  type ParsedDeactivateCredentialTypeInstruction,
  type ParsedDeactivateDidDocumentInstruction,
  type ParsedEnableProtocolFeesInstruction,
  type ParsedFileDisputeInstruction,
  type ParsedGenerateComplianceReportInstruction,
  type ParsedInitializeAuditTrailInstruction,
  type ParsedInitializeGovernanceProposalInstruction,
  type ParsedInitializeProtocolConfigInstruction,
  type ParsedInitializeRbacConfigInstruction,
  type ParsedInitializeReputationMetricsInstruction,
  type ParsedInitializeStakingConfigInstruction,
  type ParsedInitReentrancyGuardInstruction,
  type ParsedIssueCredentialInstruction,
  type ParsedLinkExternalIdInstruction,
  type ParsedManageAgentStatusInstruction,
  type ParsedRecordPayaiPaymentInstruction,
  type ParsedRegisterAgentCompressedInstruction,
  type ParsedRegisterAgentInstruction,
  type ParsedRegisterGhostMetadataInstruction,
  type ParsedResetReentrancyGuardInstruction,
  type ParsedResolveDidDocumentInstruction,
  type ParsedRevokeAuthorizationInstruction,
  type ParsedRevokeCredentialInstruction,
  type ParsedSlashStakeInstruction,
  type ParsedStakeGhostInstruction,
  type ParsedSubmitDeliveryInstruction,
  type ParsedSubmitServiceRatingInstruction,
  type ParsedUnstakeGhostInstruction,
  type ParsedUpdateAgentInstruction,
  type ParsedUpdateAgentReputationInstruction,
  type ParsedUpdateAgentServiceInstruction,
  type ParsedUpdateCrosschainStatusInstruction,
  type ParsedUpdateDidDocumentInstruction,
  type ParsedUpdateGhostScoreInstruction,
  type ParsedUpdateProtocolConfigInstruction,
  type ParsedUpdateReputationTagsInstruction,
  type ParsedUpdateReputationWithAuthInstruction,
  type ParsedUpdateSourceReputationInstruction,
  type ParsedVerifyAgentInstruction,
  type ParsedVerifyAuthorizationInstruction,
} from "../instructions";

export const GHOSTSPEAK_MARKETPLACE_PROGRAM_ADDRESS =
  "4wHjA2a5YC4twZb4NQpwZpixo5FgxxzuJUrCG7UnF9pB" as Address<"4wHjA2a5YC4twZb4NQpwZpixo5FgxxzuJUrCG7UnF9pB">;

export enum GhostspeakMarketplaceAccount {
  Agent,
  AgentReputationAuth,
  AgentTreeConfig,
  AgentVerification,
  AuditTrail,
  AuthorizationUsageRecord,
  ComplianceReport,
  Credential,
  CredentialTemplate,
  CredentialType,
  DidDocument,
  ExternalIdMapping,
  GhostProtectEscrow,
  GovernanceProposal,
  Multisig,
  ProtocolConfig,
  RbacConfig,
  ReentrancyGuard,
  ReputationMetrics,
  StakingAccount,
  StakingConfig,
  UserRegistry,
}

export function identifyGhostspeakMarketplaceAccount(
  account: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): GhostspeakMarketplaceAccount {
  const data = "data" in account ? account.data : account;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([47, 166, 112, 147, 155, 197, 86, 7]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.Agent;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([30, 249, 165, 44, 155, 194, 188, 175]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.AgentReputationAuth;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([145, 145, 156, 0, 197, 232, 130, 245]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.AgentTreeConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([128, 155, 95, 241, 66, 207, 166, 59]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.AgentVerification;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([171, 223, 253, 181, 134, 88, 66, 26]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.AuditTrail;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([109, 102, 102, 17, 210, 84, 85, 210]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.AuthorizationUsageRecord;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([75, 146, 78, 26, 130, 240, 228, 35]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.ComplianceReport;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([145, 44, 68, 220, 67, 46, 100, 135]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.Credential;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([229, 129, 99, 91, 179, 207, 66, 75]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.CredentialTemplate;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([132, 171, 20, 181, 39, 219, 217, 112]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.CredentialType;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([109, 220, 168, 224, 33, 173, 192, 166]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.DidDocument;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([180, 218, 64, 128, 181, 84, 116, 180]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.ExternalIdMapping;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([38, 0, 98, 160, 102, 4, 51, 160]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.GhostProtectEscrow;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([53, 107, 240, 190, 43, 73, 65, 143]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.GovernanceProposal;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([224, 116, 121, 186, 68, 161, 79, 236]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.Multisig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([207, 91, 250, 28, 152, 179, 215, 209]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.ProtocolConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([177, 94, 184, 202, 221, 112, 110, 38]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.RbacConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([207, 227, 141, 11, 194, 21, 193, 32]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.ReentrancyGuard;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([8, 160, 71, 30, 66, 150, 108, 33]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.ReputationMetrics;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([52, 178, 251, 157, 180, 186, 98, 234]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.StakingAccount;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([45, 134, 252, 82, 37, 57, 84, 25]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.StakingConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([37, 84, 98, 14, 130, 63, 210, 138]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceAccount.UserRegistry;
  }
  throw new Error(
    "The provided account could not be identified as a ghostspeakMarketplace account.",
  );
}

export enum GhostspeakMarketplaceInstruction {
  ActivateAgent,
  ApproveDelivery,
  ArbitrateDispute,
  AutoCreateGhost,
  ClaimGhost,
  CreateAgentAuthorization,
  CreateCredentialTemplate,
  CreateCredentialType,
  CreateDidDocument,
  CreateEscrow,
  CreateMultisig,
  DeactivateAgent,
  DeactivateCredentialTemplate,
  DeactivateCredentialType,
  DeactivateDidDocument,
  EnableProtocolFees,
  FileDispute,
  GenerateComplianceReport,
  InitReentrancyGuard,
  InitializeAuditTrail,
  InitializeGovernanceProposal,
  InitializeProtocolConfig,
  InitializeRbacConfig,
  InitializeReputationMetrics,
  InitializeStakingConfig,
  IssueCredential,
  LinkExternalId,
  ManageAgentStatus,
  RecordPayaiPayment,
  RegisterAgent,
  RegisterAgentCompressed,
  RegisterGhostMetadata,
  ResetReentrancyGuard,
  ResolveDidDocument,
  RevokeAuthorization,
  RevokeCredential,
  SlashStake,
  StakeGhost,
  SubmitDelivery,
  SubmitServiceRating,
  UnstakeGhost,
  UpdateAgent,
  UpdateAgentReputation,
  UpdateAgentService,
  UpdateCrosschainStatus,
  UpdateDidDocument,
  UpdateGhostScore,
  UpdateProtocolConfig,
  UpdateReputationTags,
  UpdateReputationWithAuth,
  UpdateSourceReputation,
  VerifyAgent,
  VerifyAuthorization,
}

export function identifyGhostspeakMarketplaceInstruction(
  instruction: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): GhostspeakMarketplaceInstruction {
  const data = "data" in instruction ? instruction.data : instruction;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([252, 139, 87, 21, 195, 152, 29, 217]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.ActivateAgent;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([28, 233, 51, 115, 33, 220, 41, 28]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.ApproveDelivery;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([225, 89, 166, 101, 215, 40, 191, 4]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.ArbitrateDispute;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([50, 170, 232, 73, 238, 200, 180, 16]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.AutoCreateGhost;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([149, 107, 35, 233, 252, 101, 148, 225]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.ClaimGhost;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([48, 219, 232, 202, 151, 97, 230, 20]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.CreateAgentAuthorization;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([183, 109, 12, 128, 134, 8, 139, 144]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.CreateCredentialTemplate;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([211, 208, 67, 175, 20, 248, 8, 227]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.CreateCredentialType;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([253, 40, 200, 239, 69, 147, 82, 182]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.CreateDidDocument;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([253, 215, 165, 116, 36, 108, 68, 80]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.CreateEscrow;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([148, 146, 240, 10, 226, 215, 167, 174]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.CreateMultisig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([205, 171, 239, 225, 82, 126, 96, 166]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.DeactivateAgent;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([177, 8, 195, 104, 56, 34, 84, 162]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.DeactivateCredentialTemplate;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([110, 174, 221, 244, 36, 206, 60, 237]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.DeactivateCredentialType;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([77, 13, 56, 161, 67, 155, 206, 119]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.DeactivateDidDocument;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([9, 115, 79, 19, 158, 209, 221, 38]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.EnableProtocolFees;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([210, 63, 221, 114, 212, 97, 195, 156]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.FileDispute;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([213, 97, 79, 234, 22, 228, 14, 32]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.GenerateComplianceReport;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([156, 109, 115, 85, 12, 60, 245, 99]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.InitReentrancyGuard;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([145, 182, 236, 249, 212, 17, 175, 161]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.InitializeAuditTrail;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([137, 84, 234, 206, 17, 58, 54, 215]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.InitializeGovernanceProposal;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([28, 50, 43, 233, 244, 98, 123, 118]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.InitializeProtocolConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([215, 68, 129, 228, 237, 165, 0, 240]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.InitializeRbacConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([228, 11, 207, 44, 52, 188, 169, 237]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.InitializeReputationMetrics;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([78, 164, 6, 115, 206, 48, 168, 105]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.InitializeStakingConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([255, 193, 171, 224, 68, 171, 194, 87]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.IssueCredential;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([156, 102, 141, 155, 175, 13, 29, 86]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.LinkExternalId;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([164, 219, 91, 38, 45, 31, 33, 47]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.ManageAgentStatus;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([165, 202, 159, 139, 65, 65, 36, 163]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.RecordPayaiPayment;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([135, 157, 66, 195, 2, 113, 175, 30]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.RegisterAgent;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([15, 6, 94, 55, 65, 80, 123, 248]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.RegisterAgentCompressed;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([34, 233, 111, 236, 212, 22, 26, 254]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.RegisterGhostMetadata;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([93, 74, 168, 125, 46, 153, 9, 255]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.ResetReentrancyGuard;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([168, 180, 218, 211, 184, 19, 102, 12]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.ResolveDidDocument;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([222, 179, 207, 59, 191, 78, 24, 248]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.RevokeAuthorization;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([38, 123, 95, 95, 223, 158, 169, 87]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.RevokeCredential;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([190, 242, 137, 27, 41, 18, 233, 37]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.SlashStake;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([5, 196, 24, 54, 196, 56, 173, 191]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.StakeGhost;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([217, 177, 33, 54, 136, 185, 123, 96]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.SubmitDelivery;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([23, 160, 228, 88, 168, 145, 129, 19]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.SubmitServiceRating;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([252, 101, 172, 252, 1, 4, 12, 116]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.UnstakeGhost;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([85, 2, 178, 9, 119, 139, 102, 164]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.UpdateAgent;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([80, 227, 92, 245, 231, 37, 99, 180]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.UpdateAgentReputation;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([87, 146, 181, 198, 252, 68, 243, 102]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.UpdateAgentService;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([22, 167, 59, 238, 22, 231, 239, 146]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.UpdateCrosschainStatus;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([64, 216, 17, 91, 205, 94, 45, 57]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.UpdateDidDocument;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([213, 152, 5, 80, 163, 224, 151, 120]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.UpdateGhostScore;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([197, 97, 123, 54, 221, 168, 11, 135]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.UpdateProtocolConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([206, 96, 254, 186, 129, 180, 103, 198]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.UpdateReputationTags;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([61, 236, 225, 167, 134, 43, 53, 93]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.UpdateReputationWithAuth;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([161, 240, 255, 69, 130, 227, 71, 123]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.UpdateSourceReputation;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([206, 212, 108, 12, 105, 61, 100, 66]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.VerifyAgent;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([43, 9, 131, 59, 74, 118, 113, 170]),
      ),
      0,
    )
  ) {
    return GhostspeakMarketplaceInstruction.VerifyAuthorization;
  }
  throw new Error(
    "The provided instruction could not be identified as a ghostspeakMarketplace instruction.",
  );
}

export type ParsedGhostspeakMarketplaceInstruction<
  TProgram extends string = "4wHjA2a5YC4twZb4NQpwZpixo5FgxxzuJUrCG7UnF9pB",
> =
  | ({
      instructionType: GhostspeakMarketplaceInstruction.ActivateAgent;
    } & ParsedActivateAgentInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.ApproveDelivery;
    } & ParsedApproveDeliveryInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.ArbitrateDispute;
    } & ParsedArbitrateDisputeInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.AutoCreateGhost;
    } & ParsedAutoCreateGhostInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.ClaimGhost;
    } & ParsedClaimGhostInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.CreateAgentAuthorization;
    } & ParsedCreateAgentAuthorizationInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.CreateCredentialTemplate;
    } & ParsedCreateCredentialTemplateInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.CreateCredentialType;
    } & ParsedCreateCredentialTypeInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.CreateDidDocument;
    } & ParsedCreateDidDocumentInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.CreateEscrow;
    } & ParsedCreateEscrowInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.CreateMultisig;
    } & ParsedCreateMultisigInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.DeactivateAgent;
    } & ParsedDeactivateAgentInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.DeactivateCredentialTemplate;
    } & ParsedDeactivateCredentialTemplateInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.DeactivateCredentialType;
    } & ParsedDeactivateCredentialTypeInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.DeactivateDidDocument;
    } & ParsedDeactivateDidDocumentInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.EnableProtocolFees;
    } & ParsedEnableProtocolFeesInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.FileDispute;
    } & ParsedFileDisputeInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.GenerateComplianceReport;
    } & ParsedGenerateComplianceReportInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.InitReentrancyGuard;
    } & ParsedInitReentrancyGuardInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.InitializeAuditTrail;
    } & ParsedInitializeAuditTrailInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.InitializeGovernanceProposal;
    } & ParsedInitializeGovernanceProposalInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.InitializeProtocolConfig;
    } & ParsedInitializeProtocolConfigInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.InitializeRbacConfig;
    } & ParsedInitializeRbacConfigInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.InitializeReputationMetrics;
    } & ParsedInitializeReputationMetricsInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.InitializeStakingConfig;
    } & ParsedInitializeStakingConfigInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.IssueCredential;
    } & ParsedIssueCredentialInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.LinkExternalId;
    } & ParsedLinkExternalIdInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.ManageAgentStatus;
    } & ParsedManageAgentStatusInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.RecordPayaiPayment;
    } & ParsedRecordPayaiPaymentInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.RegisterAgent;
    } & ParsedRegisterAgentInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.RegisterAgentCompressed;
    } & ParsedRegisterAgentCompressedInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.RegisterGhostMetadata;
    } & ParsedRegisterGhostMetadataInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.ResetReentrancyGuard;
    } & ParsedResetReentrancyGuardInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.ResolveDidDocument;
    } & ParsedResolveDidDocumentInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.RevokeAuthorization;
    } & ParsedRevokeAuthorizationInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.RevokeCredential;
    } & ParsedRevokeCredentialInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.SlashStake;
    } & ParsedSlashStakeInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.StakeGhost;
    } & ParsedStakeGhostInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.SubmitDelivery;
    } & ParsedSubmitDeliveryInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.SubmitServiceRating;
    } & ParsedSubmitServiceRatingInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.UnstakeGhost;
    } & ParsedUnstakeGhostInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.UpdateAgent;
    } & ParsedUpdateAgentInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.UpdateAgentReputation;
    } & ParsedUpdateAgentReputationInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.UpdateAgentService;
    } & ParsedUpdateAgentServiceInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.UpdateCrosschainStatus;
    } & ParsedUpdateCrosschainStatusInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.UpdateDidDocument;
    } & ParsedUpdateDidDocumentInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.UpdateGhostScore;
    } & ParsedUpdateGhostScoreInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.UpdateProtocolConfig;
    } & ParsedUpdateProtocolConfigInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.UpdateReputationTags;
    } & ParsedUpdateReputationTagsInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.UpdateReputationWithAuth;
    } & ParsedUpdateReputationWithAuthInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.UpdateSourceReputation;
    } & ParsedUpdateSourceReputationInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.VerifyAgent;
    } & ParsedVerifyAgentInstruction<TProgram>)
  | ({
      instructionType: GhostspeakMarketplaceInstruction.VerifyAuthorization;
    } & ParsedVerifyAuthorizationInstruction<TProgram>);
